import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Vehicle,
  Email,
  Closed,
  Tick,
  plusCircle,
  Noimage,
} from "../../common/imagePath";
import Deliveriescard from "../Modal/DeliveriesCard";

function SalesCard({
  callback,
  data,
  onCancel,
  visible,
  salesdeliverydata,
  saleDropdown,
  jobId
}) {
  // const { onCancel } = props;
  // console.log(
  //   "SalesCard ==> ",
  //   callback,
  //   data,
  //   onCancel,
  //   visible,
  //   salesdeliverydata
  // );
  let customerData = data;
  console.log(customerData, "customerData")
  const paramObject = useParams();
  // const [salesDeliveryDetails, setSalesDeliveryDetails] = useState();
  const [salesDeliveryDetails, setSalesDeliveryDetails] = useState();
  const [isSetDelivery, setIsSetDelivery] = useState(
    salesdeliverydata != null && salesdeliverydata.Saleid > 0 ? true : false
  );
  const [showEdit, setShowEdit] = useState(false);
  const [newData, setNewData] = useState(data);

  //accordian

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  //////


  console.log("newData", newData);

  let supplierAddress =
    newData?.Address1 +
    " " +
    newData?.Address2 +
    ", " +
    newData?.City +
    ", " +
    newData?.StateProvince +
    ", " +
    newData?.Country +
    ". " +
    newData?.Zip;

  const [mailingAddress, setMailingAddress] = useState(supplierAddress);
  const [valueOfInput, setValueOfInput] = useState(supplierAddress);



  useEffect(() => {
    setNewData(data);
    setMailingAddress(supplierAddress);
  }, [data, supplierAddress]);

  useEffect(() => {
    if (paramObject.id === undefined) {
      const savedData = localStorage.getItem("dataAfterDelivery") || "";
      if (savedData == 1) {
        console.log(savedData, "savedData")
        setIsSetDelivery(true);
      }
    }
  }, [])

  const handleClick = () => {
    setValueOfInput(mailingAddress);
    setShowEdit(true);
  };

  const AddAddress = (e) => {
    // console.log("eeeearrrrrrr");
    // setValueOfInput(valueOfInput);
    setMailingAddress(valueOfInput);
    setShowEdit(false);
    callback(valueOfInput);
  };

  const handleAddress = (e) => {
    setValueOfInput(e?.target?.value);
    // setAddValue(e.target.value);
    // setShowEdit(true);
  };

  const handlePassDeliveryCardData = (e) => {
    // console.log("customerData === ==> ", customerData);
    console.log("salesdeliverydata =====> ", salesdeliverydata);
    if (salesdeliverydata != null && salesdeliverydata.Saleid > 0) {
      setSalesDeliveryDetails(salesdeliverydata);
    } else {
      setSalesDeliveryDetails(customerData);
    }
  };

  console.log(salesDeliveryDetails, "salesDeliveryDetails")

  const callbackSalesDelivery = (payload, mappedItem) => {
    callback(payload, mappedItem);
    console.log("callbackSalesDelivery payload ==> 458", payload, mappedItem);
    if (payload == "CancelDelivery") {
      setIsSetDelivery(false);
    } else {
      setIsSetDelivery(true);
      if (paramObject.id === undefined) {
        localStorage.setItem("dataAfterDelivery", 1);
      }
    }
  };

  return (
    <>
      <div
      // className="card custom-card pb-0"
      >
        <div
        //  className="card-body"
        // style={{ borderTop: "1px solid #e9ecef" }}
        >
          <div>
            <div className="row" style={{ padding: "0px" }}>
              {/* <div className="position-relative">
                <Link
                  className="position-absolute top-0 end-0 me-2"
                  to={`/manage-customers/${data.Id}`}
                  title="Edit"
                >
                  <i className="fa fa-edit text-warning fa-2x "></i>
                </Link>
              </div> */}

              <div className="col-md-2">
                <img
                  src={data.Image}
                  onError={(e) => {
                    e.currentTarget.src = Noimage;
                  }}
                  // alt={props.Name}
                  className="img-thumbnail rounded-circle mr-5"
                  width="60px"
                  height="65px"
                />
              </div>

              <div className="col-10">
                <Link to={`/manage-customers/${data.Id}`} class="text-dark">
                  <span style={{ fontSize: "15px" }}>
                    {data.FirstName} {data.LastName} ({data.CompanyName})
                  </span>{" "}
                </Link>
                {/* <br></br> */}
                {/* <span
                  className="text-success text-bold"
                  style={{ fontSize: "15px" }}
                >
                  Balance : {data.Balance}
                </span>{" "} */}
                <br></br>
                {
                  jobId == 1  ? (
                    <span
                      className="text-success text-bold"
                      style={{ fontSize: "15px" }}
                    >
                      Inward : {data.Inward_Quantity==null ? 0 : parseFloat(data.Inward_Quantity).toFixed(2)}
                    </span>
                  ) :
                    (
                      <span
                        className="text-success text-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Outward : {data.Outward_Quantity==null ? 0 :  parseFloat(data.Outward_Quantity).toFixed(2)}
                      </span>
                    )
                }
                <br></br>
                <span> {data.Email}</span>
                <br></br>
              </div>
              {/* <p>{props.bio}</p> */}
            </div>

            {/* This is the code before the accordian */}

            {/* <div className="row">
              <div className="col-12">
                <span>
                  {showEdit ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                      }}
                    >
                      <input
                        id="MailingAddress"
                        name="MailingAddress"
                        placeholder="Mailing Address"
                        className="form-control w-100"
                        style={{ border: "none" }}
                        value={valueOfInput}
                        defaultValue={data.Address1}
                        // onChange={(e) => setValueOfInput(e.target.value)}
                        onChange={(e) => handleAddress(e)}
                      ></input>
                      <button
                        className="btn btn-outline-primary btn-sm m-1"
                        onClick={() => AddAddress()}
                      >
                        <i className="fa fa-check" aria-hidden="true"></i>
                      </button>
                      <button
                        className="btn btn-outline-danger btn-sm m-1"
                        onClick={() => setShowEdit(false)}
                      >
                        <i className="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  ) : (
                    <div>
                      <p>
                        <i
                          className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                          style={{ fontSize: "16px" }}
                        ></i>
                        {mailingAddress}
                        &nbsp;&nbsp;
                        <i
                          className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                          style={{ fontSize: "16px", cursor: "pointer" }}
                          onClick={handleClick}
                        ></i>
                      </p>
                    </div>
                  )}
                </span>
              </div>
            </div> */}

            {/* setting the accordian  */}
            <div className="accordian-item">
              <div className="accordion-header" style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                <button class="accordion-button dropdown-toggle p-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Shipping Address
                </button>
              </div>
              {isAccordionOpen && (
                <div className="accordion">
                  <div className="mb-2 col-md-12">
                    <div>
                      <div className="col-12">
                        <span>
                          {showEdit ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid lightgray",
                                borderRadius: "5px",
                              }}
                            >
                              <input
                                id="MailingAddress"
                                name="MailingAddress"
                                placeholder="Mailing Address"
                                className="form-control w-100"
                                style={{ border: "none" }}
                                value={valueOfInput}
                                defaultValue={data.Address1}
                                // onChange={(e) => setValueOfInput(e.target.value)}
                                onChange={(e) => handleAddress(e)}
                              ></input>
                              <button
                                className="btn btn-outline-primary btn-sm m-1"
                                onClick={() => AddAddress()}
                              >
                                <i className="fa fa-check" aria-hidden="true"></i>
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm m-1"
                                onClick={() => setShowEdit(false)}
                              >
                                <i className="fa fa-times" aria-hidden="true"></i>
                              </button>
                            </div>
                          ) : (
                            <div>
                              <p>
                                <i
                                  className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                                  style={{ fontSize: "16px" }}
                                ></i>
                                {mailingAddress}
                                &nbsp;&nbsp;
                                <i
                                  className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                  style={{ fontSize: "16px", cursor: "pointer" }}
                                  onClick={handleClick}
                                ></i>
                              </p>
                            </div>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* <div className="card-footer">saddas</div> */}
          </div>
        </div>
        <div className="card-footer p-0">
          <div className="row">
            {/* {saleDropdown !== 4 && (
              <div
                className="col-md-4  text-center"
                style={{ borderRight: "1px solid #ccc", padding: "5px 0px" }}
              >
                <Link
                  onClick={(e) => handlePassDeliveryCardData(e)}
                  data-bs-target="#DeliveriesModal"
                  data-bs-toggle="modal"
                  className={isSetDelivery ? "text-success" : ""}
                >
                  &nbsp;<span>Deliveries</span>
                </Link>
                <Deliveriescard
                  callback={callbackSalesDelivery}
                  salesDeliveryDetails={salesDeliveryDetails}
                />
              </div>
            )} */}
            <div
              className={`${saleDropdown !== 4 ? 'col-md-6' : 'col-md-6'}  text-center`}
              style={{ padding: "5px 0px" }}
            >
              <Link to={`/manage-customers/${data.Id}`} title="Edit">
                {/* <i className="fa fa-edit text-warning fa-lg " style={{ marginRight: "0.5rem" }}></i> */}
                <span>Edit Customer</span>
              </Link>
            </div>
            <div
              className={`${saleDropdown !== 4 ? 'col-md-4' : 'col-md-6'}  text-center`}
              style={{ borderLeft: "1px solid #ccc", padding: "5px 0px" }}
            >
              <Link type="button" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* <img
                  src={Closed}
                  style={{
                    marginRight: "0.5rem",
                    width: "0.9rem",
                    height: "0.9rem",
                  }}
                /> */}
                <span onClick={onCancel}>Detach</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesCard;
